import React from "react";
import { ShieldCheck, CheckCircle2, Clock } from "lucide-react";

const REGISTRATIONS = [
  { name: "Companies House", detail: "Marioway Benefits Consultancy Ltd · Company Number 12784422 · Registered in England and Wales", confirmed: true },
  { name: "University qualification", detail: "Founder & Director — BSc Accounting and Financial Management, Canterbury Christ Church University (2026)", confirmed: true },
  { name: "ICO data protection registration", detail: "", confirmed: false },
  { name: "HMRC agent registration", detail: "", confirmed: false },
  { name: "Anti-money-laundering (AML) supervision", detail: "", confirmed: false },
  { name: "AdviceUK membership", detail: "", confirmed: false },
  { name: "AAT / ICB membership or licence", detail: "", confirmed: false },
  { name: "Immigration Advice Authority (IAA) registration", detail: "", confirmed: false },
];

export const Standards = () => {
  const confirmed = REGISTRATIONS.filter((r) => r.confirmed);
  return (
    <section id="standards" className="section bg-white">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="eyebrow"><ShieldCheck size={12} /> Professional Standards &amp; Regulatory Information</span>
          <h2 className="font-display text-4xl sm:text-5xl mt-4 text-[#002B7F] leading-[1.05]">
            Transparent about <span className="text-[#F37021]">what we are — and what we are not.</span>
          </h2>
          <p className="mt-4 text-[#4A4A4A] text-base">
            Marioway Benefits Consultancy Ltd is an independent administrative support and consultancy business. We list below only registrations and qualifications that are confirmed. Companies House registration is a statutory company registration and does not itself constitute professional accreditation or regulatory approval.
          </p>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          {confirmed.map((r) => (
            <div key={r.name} className="soft-card p-5 flex items-start gap-4" data-testid={`standard-${r.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <span className="icon-tile orange" style={{ width: 40, height: 40 }}><CheckCircle2 size={18} /></span>
              <div>
                <div className="font-bold text-[#002B7F]">{r.name}</div>
                <div className="text-[13.5px] text-[#4A4A4A] mt-1">{r.detail}</div>
                <div className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-bold tracking-[0.14em] uppercase text-[#1F5D2D]">Confirmed</div>
              </div>
            </div>
          ))}
          <div className="rounded-2xl border border-dashed border-[#C9D2E0] p-5 flex items-start gap-4 text-[#4A4A4A]" data-testid="standards-pending">
            <span className="icon-tile" style={{ width: 40, height: 40 }}><Clock size={18} /></span>
            <div className="text-[13.5px] leading-relaxed">
              <div className="font-bold text-[#002B7F]">Additional registrations</div>
              Further professional registrations, memberships or supervisions will be listed here only once officially obtained and verified. Until then, Marioway does not hold itself out as a regulated immigration adviser, tax agent, law firm, chartered or certified accountant, or as supervised or accredited by any professional body.
            </div>
          </div>
        </div>

        <div className="mt-8 rounded-2xl bg-[#F5F7FA] border border-[#E6EAF0] p-5 md:p-6 text-[13px] text-[#4A4A4A] leading-relaxed space-y-2" data-testid="standards-disclaimers">
          <p><span className="font-bold text-[#002B7F]">Immigration.</span> Marioway Benefits Consultancy Ltd is not currently presented as an Immigration Advice Authority-regulated immigration adviser. Where regulated immigration advice is required, clients should obtain advice from an appropriately authorised immigration adviser or solicitor.</p>
          <p><span className="font-bold text-[#002B7F]">Accounting &amp; tax.</span> Tax-agent representation and regulated or supervised services are offered only where the necessary registrations and authorisations are in place. Clients remain responsible for the accuracy of information supplied to Marioway. We do not guarantee tax refunds, HMRC decisions or specific financial outcomes.</p>
          <p><span className="font-bold text-[#002B7F]">Legal.</span> Marioway Benefits Consultancy Ltd is not a law firm and does not undertake reserved legal activities unless appropriately authorised.</p>
          <p><span className="font-bold text-[#002B7F]">Education.</span> References to educational institutions identify organisations with which clients may interact and do not imply endorsement or partnership.</p>
        </div>
      </div>
    </section>
  );
};
